import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { Post, Status } from "../../pages/Enterprise/modules/Post/types";

const getPosts = async (id?: string): Promise<Post[]> => {
  try {
    const response = await axiosInstance.get<Post[]>(
      `/post/${id ? `subaccount/${id}` : "all"}`
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível obter as postagens.",
    });

    throw new Error(`${error}`);
  }
};

const createPost = async (id: string, data: Post): Promise<Post> => {
  try {
    const response = await axiosInstance.post<Post>(`/post/${id}`, data);
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar a postagem.",
    });

    throw new Error(`${error}`);
  }
};

const updatePost = async (id: string, status: Status): Promise<Post> => {
  try {
    const response = await axiosInstance.patch<Post>(`/post/${id}`, { status });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível editar a postagem.",
    });

    throw new Error(`${error}`);
  }
};

export const postService = {
  getPosts,
  createPost,
  updatePost,
};
